import React, { useState, useEffect } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

import TicketsManager from "../../components/TicketsManagerTabs/";
import Ticket from "../../components/Ticket/";
import ContactChat from "../../components/ContactChat/";
import logo from "../../assets/logo.png"; //PLW DESIGN LOGO//
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";

// Largura da coluna de tickets (era 450). Encolheu para devolver espaço à
// conversa: com o ContactDrawer (320px) aberto em 1366 a conversa cai abaixo
// dos 600px de maxWidth dos balões e eles quebram feio.
const CONTACTS_WIDTH = 400;

const useStyles = makeStyles(theme => ({
	chatContainer: {
		flex: 1,
		// backgroundColor: "#eee",
		padding: 4, //Aqui ele ajusta espaço na tela de ticket
		height: `calc(100% - 48px)`,
		overflowY: "hidden",
	},

	chatPapper: {
		// backgroundColor: "red",
		display: "flex",
		height: "100%",
	},

	contactsWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		overflowY: "hidden",
		// Em telas menores, usa porcentagem
		maxWidth: "100%",
		flexBasis: "100%",
		// Em telas maiores (desktop), usa largura fixa
		[theme.breakpoints.up('md')]: {
			width: CONTACTS_WIDTH,
			minWidth: CONTACTS_WIDTH,
			maxWidth: CONTACTS_WIDTH,
			flexBasis: CONTACTS_WIDTH,
		},
	},
	messagesWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		// Em telas menores
		maxWidth: "100%",
		flexBasis: "100%",
		// Em telas maiores (desktop), ocupa o resto. Espelha contactsWrapper —
		// os dois TÊM que usar a mesma constante.
		[theme.breakpoints.up('md')]: {
			maxWidth: `calc(100% - ${CONTACTS_WIDTH}px)`,
			flexBasis: `calc(100% - ${CONTACTS_WIDTH}px)`,
		},
	},
	welcomeMsg: {
		backgroundColor: theme.palette.boxticket, //DARK MODE PLW DESIGN//
		display: "flex",
		justifyContent: "space-evenly",
		alignItems: "center",
		height: "100%",
		textAlign: "center",
	},
}));

const TicketsCustom = () => {
	const classes = useStyles();
	const { ticketId } = useParams();
	const history = useHistory();
	const location = useLocation();
	const [selectedContact, setSelectedContact] = useState(null);

	// Limpar contato selecionado quando navegar para um ticket
	useEffect(() => {
		if (ticketId) {
			setSelectedContact(null);
		}
	}, [ticketId]);

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		const contactId = Number(params.get("contactId"));

		if (ticketId || !Number.isInteger(contactId) || contactId <= 0) {
			return;
		}

		let isMounted = true;

		const loadContactFromQuery = async () => {
			try {
				const { data } = await api.get(`/contacts/${contactId}`);
				if (!isMounted || !data?.id) {
					return;
				}

				setSelectedContact(data);
				history.replace("/tickets");
			} catch (err) {
				if (isMounted) {
					toastError(err);
				}
			}
		};

		loadContactFromQuery();

		return () => {
			isMounted = false;
		};
	}, [history, location.search, ticketId]);

	// Callback quando ticket é criado no ContactChat
	const handleTicketCreated = (ticketId) => {
		setSelectedContact(null);
		history.push(`/tickets/${ticketId}`);
	};

	// Callback para selecionar contato
	const handleSelectContact = (contact) => {
		setSelectedContact(contact);
		// Limpa o ticket da URL para mostrar o ContactChat
		history.push('/tickets');
	};

	return (
		<div className={classes.chatContainer}>
			<div className={classes.chatPapper}>
				<Grid container spacing={0}>
					<Grid item xs className={classes.contactsWrapper}>
						<TicketsManager onSelectContact={handleSelectContact} />
					</Grid>
					<Grid item xs className={classes.messagesWrapper}>
						{ticketId ? (
							<>
								<Ticket />
							</>
						) : selectedContact ? (
							<ContactChat 
								contact={selectedContact} 
								onTicketCreated={handleTicketCreated}
								onClose={() => setSelectedContact(null)}
							/>
						) : (
							<Paper square variant="outlined" className={classes.welcomeMsg}>
							{/* PLW DESIGN LOGO */}
							<div>
							<center><img style={{ margin: "0 auto", width: "70%" }} src={logo} alt="logologin" /></center>
							</div>
							{/* PLW DESIGN LOGO */}
							{/*<span>{i18n.t("chat.noTicketMessage")}</span>*/}
							</Paper>
						)}
					</Grid>
				</Grid>
			</div>
		</div>
	);
};

export default TicketsCustom;
